import { render, staticRenderFns } from "./Newsticker.vue?vue&type=template&id=3e3c1e7e&scoped=true&"
import script from "./Newsticker.vue?vue&type=script&lang=js&"
export * from "./Newsticker.vue?vue&type=script&lang=js&"
import style0 from "./Newsticker.vue?vue&type=style&index=0&id=3e3c1e7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c1e7e",
  null
  
)

export default component.exports